import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
// import { isLogin } from '../utils/';

const mapStateToProps = function (state: any) {
	return {
		auth: state.auth,
	};
};

const PublicRoute = ({ component: Component, restricted, ...rest }: any) => {
	const renderPrivateRoute = (props: any) => {
		if (rest.auth.didRegister) {
			return <Redirect to="/" />;
		} else {
			return <Redirect to="/dashboard" />;
		}
	};

	return <Route {...rest} render={(props) => (rest.auth.session ? renderPrivateRoute(props) : <Component {...props} />)} />;
};

export default connect(mapStateToProps, {})(PublicRoute);
